import React from "react";
import { Link } from "react-router-dom";
import { TspCard } from "../../../components/primitives";
import { areaText, cityOptionLabel, stateOptions, visitsInState } from "../placeModel";

// "Select State, City, Area": the route place this session's entries belong
// to. Only places with a recorded visit are offered, and all three values come
// from that visit (Record Visit) — the page pre-selects one, so nothing has to
// be typed again. Area is read-only: it is what was recorded with the visit.
export default function SelectStateCityAreaCard({ visits, stateName, onStateChange, visit, onVisitChange, missingPlace, recordVisitLink, disabled }) {
  const states = stateOptions(visits);
  const cities = stateName ? visitsInState(visits, stateName) : [];
  const showJourney = new Set(visits.map((v) => v.journey?.id)).size > 1;

  return (
    <TspCard title="Select State, City, Area">
      <div className="tsp-form-row">
        <div className="tsp-form-field">
          <label htmlFor="tsp-bd-state">Select State</label>
          <select id="tsp-bd-state" className="tsp-field-control" value={stateName} disabled={disabled || states.length === 0} onChange={(e) => onStateChange(e.target.value)}>
            <option value="">Select State</option>
            {states.map((state) => (
              <option key={state} value={state}>
                {state}
              </option>
            ))}
          </select>
        </div>
        <div className="tsp-form-field">
          <label htmlFor="tsp-bd-visit">Select City</label>
          <select id="tsp-bd-visit" className="tsp-field-control" value={visit ? String(visit.id) : ""} disabled={disabled || !stateName} onChange={(e) => onVisitChange(e.target.value)}>
            <option value="">Select City</option>
            {cities.map((v) => (
              <option key={v.id} value={v.id}>
                {cityOptionLabel(v, showJourney)}
              </option>
            ))}
          </select>
        </div>
        <div className="tsp-form-field">
          <label htmlFor="tsp-bd-area">Area</label>
          <input id="tsp-bd-area" type="text" className="tsp-field-control" value={areaText(visit)} placeholder={visit ? "No area recorded" : "Select a city"} readOnly />
        </div>
      </div>
      {visit && <p className="tsp-muted-text tsp-bd-place-note">Filled in from the visit recorded for {visit.location?.label || "this city"}{visit.journey?.journey_name ? ` (${visit.journey.journey_name})` : ""}.</p>}
      {missingPlace && (
        <p className="tsp-muted-text tsp-bd-place-note" role="status">
          This city has no recorded visit yet. <Link to={recordVisitLink}>Record the visit</Link> first, then add its book distribution.
        </p>
      )}
      {!missingPlace && visits.length === 0 && (
        <p className="tsp-muted-text tsp-bd-place-note" role="status">
          No city visit is recorded for a journey in progress yet. <Link to={recordVisitLink}>Record a visit</Link> first.
        </p>
      )}
    </TspCard>
  );
}
